import { createReducer, on } from '@ngrx/store';
import * as actions from './listProjects.actions';
import { ListProjects } from './listProjects.data';

export const stateInitial: ListProjects = new ListProjects();

const _listProjectsReducer = createReducer(stateInitial,
	on(actions.resetPaginate, (state) => state = stateInitial),
	on(actions.setCurrentPage, (state, { page }) => {
		return {
			...state,
			currentPage: page
		}
	}),
	on(actions.setCurrentFilter, (state, { filter }) => {
		return {
			...state,
			currentPage: 0,
			currentFilter: filter
		}
	}),
);

export function listProjectsReducer(state, action) {
	return _listProjectsReducer(state, action);
}
